import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// actions
import { doneIndicator, error } from '../../actions/standardActions';

// api
import postedOffersApi from '../../sources/api/postedOffersApi';

// constants
import { FETCH_POSTED_OFFERS } from '../../constants/postedOffersTypes';

// lib
import httpSaga from '../../lib/httpSaga';
import { postedOffers } from '../../schemas/Normalizr';

export function* fetchPostedOffers(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const params = action.payload;

  try {
    yield* httpSaga(
      FETCH_POSTED_OFFERS,
      call(postedOffersApi.fetchPostedOffers, params),
      postedOffers
    );
  } catch (e) {
    yield put(error(FETCH_POSTED_OFFERS, e));
  } finally {
    yield put(doneIndicator(FETCH_POSTED_OFFERS));
  }
}

export function* watchFetchMyPostedOffers() {
  yield takeEvery(FETCH_POSTED_OFFERS, fetchPostedOffers);
}

export default function* root() {
  yield all([fork(watchFetchMyPostedOffers)]);
}



// WEBPACK FOOTER //
// ./app/sagas/postedOffers/fetchPostedOffers.js